import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_NDD_80: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_NDD_80,
  },
  {
    pageId: PageId.CHAT_UPSELL_NDD_80,
  },
  {
    pageId: PageId.UPSELL_NDD_80,
  },
  {
    pageId: PageId.DOWNLOAD_NDD_80,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
